var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { "min-width": "1200px" } },
        [
          _vm.toExoSystemHc
            ? _c(
                "div",
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_VehicleInformation")) + " "
                    ),
                    !_vm.job.uuid
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "red",
                              "font-weight": "lighter"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.SaveBusinessBeforeEnterMultiGate"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticStyle: { margin: "20px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_DispatchVehicleNoteFields")
                        )
                      )
                    ]),
                    _c(
                      "span",
                      { staticStyle: { color: "red", "font-weight": "bold" } },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TTDEG")))]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "padding-bottom": "5px" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "addHcInfo",
                            type: "primary",
                            disabled: _vm.readonly || !_vm.job.uuid
                          },
                          on: { click: _vm.addHcInfoHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "delHcInfo",
                            disabled: _vm.readonly || !_vm.job.uuid,
                            type: "danger"
                          },
                          on: { click: _vm.delHcInfoHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                      )
                    ],
                    1
                  ),
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", "padding-bottom": "5px" },
                    attrs: {
                      no: "hcInfo",
                      "config-module": "20250522",
                      "grid-options": _vm.hcInfo.gridOptions,
                      "grid-params": _vm.hcInfo.gridParams,
                      "column-defs": _vm.hcInfoColumnDef,
                      "row-data": _vm.hcInfoTrucking
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.hcInfo, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.hcInfo, "gridParams", $event)
                      },
                      gridReady: function(params) {
                        _vm.hcInfo.gridApi = params.api
                      }
                    }
                  }),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("Partners.doorInformation")) + " ")
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "padding-bottom": "5px" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "addHcDoor",
                            type: "primary",
                            disabled: _vm.readonly || !_vm.job.uuid
                          },
                          on: {
                            click: function($event) {
                              return _vm.addHcDoorHandler(false)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "delHcDoor",
                            disabled: _vm.readonly || !_vm.job.uuid,
                            type: "danger"
                          },
                          on: { click: _vm.delHcDoorHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "informationMaintenance",
                            disabled: _vm.readonly || !_vm.job.uuid,
                            type: "success"
                          },
                          on: { click: _vm.addDoor }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_InformationMaintenance")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "hcInfo",
                      "config-module": "20250523",
                      "grid-options": _vm.hcDoor.gridOptions,
                      "grid-params": _vm.hcDoor.gridParams,
                      "column-defs": _vm.hcDoorColumDef,
                      "row-data": _vm.hcDoorTrucking
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.hcDoor, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.hcDoor, "gridParams", $event)
                      },
                      gridReady: function(params) {
                        _vm.hcDoor.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.toExoSystemHc
            ? _c("div", [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.DoorToDoorLoading")) + " "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "red",
                        "font-weight": "lighter",
                        margin: "30px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.SaveBusinessBeforeEnterMultiGate")
                        )
                      )
                    ]
                  )
                ]),
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex", "flex-direction": "column" }
                  },
                  [
                    _vm.showSecondSync
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.syncToDischargingTruckingInfo }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SecondarySynchronization")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.job.multiplePickups
                      ? _c(
                          "div",
                          [
                            _vm.top.visible
                              ? _c("cargo-ag-grid", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "1",
                                    "config-module": _vm.topConfigModuel,
                                    "grid-options": _vm.top.gridOptions,
                                    "grid-params": _vm.top.gridParams,
                                    "column-defs": _vm.topColumnDefs,
                                    "row-data": _vm.trucking
                                  },
                                  on: {
                                    "update:gridParams": function($event) {
                                      return _vm.$set(
                                        _vm.top,
                                        "gridParams",
                                        $event
                                      )
                                    },
                                    "update:grid-params": function($event) {
                                      return _vm.$set(
                                        _vm.top,
                                        "gridParams",
                                        $event
                                      )
                                    },
                                    gridReady: function(params) {
                                      _vm.topgridApi = params.api
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.job.multiplePickups
                      ? _c(
                          "div",
                          {
                            staticClass: "app-main-inner-row operations",
                            staticStyle: { padding: "5px 0" }
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.cooperateEdit,
                                    expression: "cooperateEdit"
                                  }
                                ],
                                staticClass: "triggers"
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "2",
                                          type: "primary",
                                          disabled: _vm.readonly
                                        },
                                        on: { click: _vm.copyNewHandler }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.copyAndAddPoItems"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "3",
                                          type: "primary",
                                          disabled: _vm.readonly
                                        },
                                        on: { click: _vm.addHandler }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "4",
                                          disabled: !_vm.btnEnable.btDel,
                                          type: "danger"
                                        },
                                        on: { click: _vm.delHandler }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Delete")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.job.multiplePickups ? _c("el-divider") : _vm._e(),
                    _c(
                      "el-form",
                      {
                        staticClass: "inline-form",
                        attrs: {
                          inline: true,
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { width: "auto" },
                                  attrs: {
                                    no: "5.1",
                                    disabled:
                                      _vm.readonly || _vm.action === "add"
                                  },
                                  on: { change: _vm.multiPickupsChangeHandler },
                                  model: {
                                    value: _vm.job.multiplePickups,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "multiplePickups", $$v)
                                    },
                                    expression: "job.multiplePickups"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.MultiDoors")) + " "
                                  )
                                ]
                              ),
                              _vm.job.lob === "SE" && _vm.multiTruckingShow
                                ? _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { width: "auto" },
                                      attrs: {
                                        no: "5.2",
                                        disabled:
                                          _vm.readonly || _vm.action === "add"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.changePickupsOrCabinets(
                                            "Cabinets"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.multipleCabinets,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "multipleCabinets",
                                            $$v
                                          )
                                        },
                                        expression: "job.multipleCabinets"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("SeaExport.MultiCabinets")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("br"),
                              _vm.job.lob !== "SE"
                                ? _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { width: "auto" },
                                      attrs: {
                                        no: "loadingPortService",
                                        disabled: _vm.readonly
                                      },
                                      on: {
                                        change: _vm.onLoadingPortServiceChange
                                      },
                                      model: {
                                        value:
                                          _vm.truckingInfo.loadingPortService,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.truckingInfo,
                                            "loadingPortService",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "truckingInfo.loadingPortService"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_PortOfLoading"
                                            )
                                          ) +
                                          _vm._s(_vm.$t("SeaExport.Service")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.job.lob !== "SE"
                                ? _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { width: "auto" },
                                      attrs: {
                                        no: "dischargingPortService",
                                        disabled: _vm.readonly
                                      },
                                      on: {
                                        change:
                                          _vm.onDischargingPortServiceChange
                                      },
                                      model: {
                                        value:
                                          _vm.truckingInfo
                                            .dischargingPortService,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.truckingInfo,
                                            "dischargingPortService",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "truckingInfo.dischargingPortService"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_PortOfDischarge"
                                            )
                                          ) +
                                          _vm._s(_vm.$t("SeaExport.Service")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm.job.multiplePickups ||
                    _vm.job.lob === "SE" ||
                    _vm.job.lob === "SI" ||
                    _vm.job.lob === "AI"
                      ? _c(
                          "el-form",
                          {
                            staticClass: "inline-form",
                            attrs: {
                              inline: true,
                              "label-width": "100px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "label",
                                  { staticStyle: { width: "55px" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                                ),
                                _c("el-input-number", {
                                  staticStyle: { width: "118px" },
                                  attrs: {
                                    no: "6",
                                    value:
                                      _vm.truckingInfo.quantity || undefined,
                                    disabled: _vm.readonly,
                                    min: 0,
                                    max: 999999,
                                    precision: 0,
                                    "controls-position": "right"
                                  },
                                  on: {
                                    input: function(val) {
                                      _vm.truckingInfo.quantity = val
                                    }
                                  }
                                }),
                                _c(
                                  "label",
                                  { staticStyle: { width: "55px" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Weight")))]
                                ),
                                _c("el-input-number", {
                                  staticStyle: { width: "118px" },
                                  attrs: {
                                    no: "7",
                                    value: _vm.truckingInfo.weight || undefined,
                                    disabled: _vm.readonly,
                                    min: 0,
                                    max: 999999,
                                    precision: 3,
                                    "controls-position": "right"
                                  },
                                  on: {
                                    input: function(val) {
                                      _vm.truckingInfo.weight = val
                                    }
                                  }
                                }),
                                _c(
                                  "label",
                                  { staticStyle: { width: "55px" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))]
                                ),
                                _c("el-input-number", {
                                  staticStyle: { width: "118px" },
                                  attrs: {
                                    no: "8",
                                    value: _vm.truckingInfo.cubage || undefined,
                                    disabled: _vm.readonly,
                                    min: 0,
                                    max: 999999,
                                    precision: 3,
                                    "controls-position": "right"
                                  },
                                  on: {
                                    input: function(val) {
                                      _vm.truckingInfo.cubage = val
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.job.multiplePickups
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    staticStyle: { "margin-left": "30px" },
                                    attrs: {
                                      label: "S/O No.",
                                      "label-width": "100px"
                                    }
                                  },
                                  [
                                    _c("so-no-selector", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        "so-no": _vm.soNo,
                                        disabled: _vm.readonly
                                      },
                                      model: {
                                        value: _vm.truckingInfo.soNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.truckingInfo,
                                            "soNo",
                                            $$v
                                          )
                                        },
                                        expression: "truckingInfo.soNo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "trucking-form" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              disabled: _vm.readonly,
                              "label-width": "140px",
                              "label-position": "left"
                            }
                          },
                          [
                            !_vm.isSalesForSzfs
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: {
                                      label: _vm.$t("SeaExport.HaulageCompany")
                                    }
                                  },
                                  [
                                    _c("cargo-company-select", {
                                      staticStyle: {
                                        width: "400px",
                                        display: "inline-block"
                                      },
                                      attrs: {
                                        no: "9",
                                        disabled: _vm.readonly,
                                        "method-params": {
                                          truckCmp: true,
                                          active: true
                                        },
                                        "default-value":
                                          _vm.truckingInfo.carryingCmp || ""
                                      },
                                      on: {
                                        change: function(p) {
                                          _vm.oldCarryingCmp =
                                            _vm.truckingInfo.carryingCmp || 0
                                          _vm.truckingInfo.carryingCmp =
                                            p.value || 0
                                          _vm.carryingCmpChangeHandler()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.isSalesForSzfs
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.HaulageContactPerson"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "400px" },
                                        attrs: {
                                          no: "10",
                                          placeholder: _vm.readonly
                                            ? ""
                                            : _vm.$t(
                                                "CargoMsg.Cargo_PleaseSelect"
                                              ),
                                          "allow-create": true,
                                          clearable: true,
                                          filterable: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.carryingContactsChangeHandler(
                                              false,
                                              false
                                            )
                                          },
                                          blur: _vm.selectContactBlur
                                        },
                                        model: {
                                          value: _vm.truckingInfo.driver,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.truckingInfo,
                                              "driver",
                                              $$v
                                            )
                                          },
                                          expression: "truckingInfo.driver"
                                        }
                                      },
                                      _vm._l(_vm.carryingContacts, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.contactPerson,
                                            value: item.contactPerson
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: { label: _vm.loadingDateLabel }
                              },
                              [
                                _c("el-date-picker", {
                                  ref: "loadingDate",
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    no: "11",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm:ss"
                                  },
                                  on: {
                                    blur: function() {
                                      _vm.handleBlur(
                                        "loadingDate",
                                        null,
                                        true,
                                        true,
                                        _vm.truckingInfo
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.truckingInfo.loadingDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "loadingDate",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.loadingDate"
                                  }
                                })
                              ],
                              1
                            ),
                            !_vm.isSalesForSzfs
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: { label: _vm.$t("Warehouse.Driver") }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "400px" },
                                        attrs: {
                                          no: "12",
                                          placeholder: _vm.readonly
                                            ? ""
                                            : _vm.$t(
                                                "CargoMsg.Cargo_PleaseSelect"
                                              ),
                                          "allow-create": true,
                                          clearable: true,
                                          filterable: ""
                                        },
                                        on: {
                                          change:
                                            _vm.driverInfomationsChangeHandler
                                        },
                                        model: {
                                          value: _vm.truckingInfo.driverName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.truckingInfo,
                                              "driverName",
                                              $$v
                                            )
                                          },
                                          expression: "truckingInfo.driverName"
                                        }
                                      },
                                      _vm._l(_vm.driverInfomations, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.driverName,
                                            value: item.driverName
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: { label: _vm.$t("SeaExport.travelTime") }
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "105px" },
                                  attrs: {
                                    no: "13",
                                    min: 0,
                                    "controls-position": "right"
                                  },
                                  model: {
                                    value: _vm.truckingInfo.travelHour,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "travelHour",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.travelHour"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { margin: "10px" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Hour")))]
                                ),
                                _c("el-input-number", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "14",
                                    min: 0,
                                    max: 59,
                                    "controls-position": "right"
                                  },
                                  model: {
                                    value: _vm.truckingInfo.travelMinute,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "travelMinute",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.travelMinute"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { margin: "10px" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Minute")))]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: {
                                  label: _vm.$t("SeaExport.DoorContactPerson")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: { no: "15" },
                                  model: {
                                    value: _vm.truckingInfo.doorMan,
                                    callback: function($$v) {
                                      _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                                    },
                                    expression: "truckingInfo.doorMan"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: {
                                  label: _vm.$t("SeaExport.DoorAddress")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    no: "16",
                                    type: "textarea",
                                    rows: 3
                                  },
                                  model: {
                                    value: _vm.truckingInfo.doorAddr,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "doorAddr",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.doorAddr"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: { label: _vm.$t("SeaExport.ZIP") }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: { no: "zipCode" },
                                  model: {
                                    value: _vm.truckingInfo.zipCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.truckingInfo, "zipCode", $$v)
                                    },
                                    expression: "truckingInfo.zipCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { "label-width": "0" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "custom",
                                        attrs: {
                                          label: _vm.$t("Pricing.BelongingCity")
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "160px" },
                                          attrs: {
                                            no: "17",
                                            disabled: _vm.readonly,
                                            "tag-name":
                                              _vm.$store.getters.language ===
                                              "zh"
                                                ? "chineseName"
                                                : "englishName",
                                            "tag-value": "code",
                                            cache: false,
                                            filterable: "",
                                            "default-value":
                                              _vm.truckingInfo.cityCode,
                                            "static-options": _vm.cityList,
                                            placeholder: _vm.$t(
                                              "SeaExport.PleaseSelect"
                                            )
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              return (_vm.truckingInfo.cityCode =
                                                p.value)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form",
                                      {
                                        attrs: {
                                          "label-width": "100px",
                                          "label-position": "left"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "custom",
                                            attrs: {
                                              label: _vm.$t(
                                                "Warehouse.PalletSum"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input-number", {
                                              staticStyle: { width: "140px" },
                                              attrs: {
                                                no: "18",
                                                value:
                                                  _vm.truckingInfo.palletSum,
                                                disabled: _vm.readonly,
                                                min: 0,
                                                max: 999999999999,
                                                precision: 0,
                                                controls: false
                                              },
                                              on: {
                                                input: function(val) {
                                                  _vm.truckingInfo.palletSum =
                                                    val || 0
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "PO" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    no: "po",
                                    disabled: _vm.readonly,
                                    "filter-chars": false,
                                    type: "textarea",
                                    rows: 3
                                  },
                                  model: {
                                    value: _vm.truckingInfo.po,
                                    callback: function($$v) {
                                      _vm.$set(_vm.truckingInfo, "po", $$v)
                                    },
                                    expression: "truckingInfo.po"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "100px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: { label: _vm.$t("SeaExport.HaulageNo") }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "160px" },
                                  attrs: { no: "19", disabled: _vm.readonly },
                                  on: { change: _vm.refreshGrid },
                                  model: {
                                    value: _vm.truckingInfo.truckOrderNo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "truckOrderNo",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.truckOrderNo"
                                  }
                                }),
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.HaulageCharge"))
                                  )
                                ]),
                                _c("el-input-number", {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    no: "40",
                                    disabled: _vm.readonly,
                                    min: 0,
                                    max: 999999999999,
                                    precision: 2,
                                    "controls-position": "right"
                                  },
                                  on: { change: _vm.truckingFeeCharge },
                                  model: {
                                    value: _vm.truckingInfo.truckingFee,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "truckingFee",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.truckingFee"
                                  }
                                }),
                                _c("span", { staticClass: "currency" }, [
                                  _vm._v(_vm._s(_vm.localCurrency))
                                ])
                              ],
                              1
                            ),
                            !_vm.isSalesForSzfs
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: { label: _vm.$t("SeaExport.Tel") }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        no: "41",
                                        disabled: _vm.readonly
                                      },
                                      on: { change: _vm.refreshGrid },
                                      model: {
                                        value: _vm.truckingInfo.driverTel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.truckingInfo,
                                            "driverTel",
                                            $$v
                                          )
                                        },
                                        expression: "truckingInfo.driverTel"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: { label: _vm.actLoadingDateLabel }
                              },
                              [
                                _c("el-date-picker", {
                                  ref: "actLoadingDate",
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    no: "42",
                                    disabled: _vm.readonly,
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm:ss"
                                  },
                                  on: {
                                    blur: function() {
                                      _vm.handleBlur(
                                        "actLoadingDate",
                                        null,
                                        true,
                                        true,
                                        _vm.truckingInfo
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.truckingInfo.actLoadingDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "actLoadingDate",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.actLoadingDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: {
                                  label: _vm.$t("SeaExport.PlateNumber")
                                }
                              },
                              [
                                _vm.isEdit
                                  ? _c("el-input", {
                                      staticStyle: { width: "280px" },
                                      attrs: {
                                        no: "43",
                                        disabled: _vm.readonly
                                      },
                                      on: {
                                        input: function(val) {
                                          _vm.truckingInfo.plateNumber = val.trim()
                                        }
                                      },
                                      model: {
                                        value: _vm.truckingInfo.plateNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.truckingInfo,
                                            "plateNumber",
                                            $$v
                                          )
                                        },
                                        expression: "truckingInfo.plateNumber"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.readonly
                                  ? _c(
                                      "span",
                                      { staticClass: "plate_number" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.truckingInfo.plateNumber)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "light",
                                      content: _vm.$t(
                                        "SeaExport.ClickVehiclePositioningAndTrack"
                                      ),
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-question vehicle-tip"
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            !_vm.isSalesForSzfs
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: {
                                      label: _vm.$t("Warehouse.DriverPhone"),
                                      disabled: _vm.txtEditEable
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        no: "45",
                                        disabled: _vm.readonly
                                      },
                                      model: {
                                        value: _vm.truckingInfo.driverPhone,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.truckingInfo,
                                            "driverPhone",
                                            $$v
                                          )
                                        },
                                        expression: "truckingInfo.driverPhone"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: { label: _vm.$t("SeaExport.Door") }
                              },
                              [
                                _c("cargo-repeat-value-select", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    placeholder: _vm.readonly
                                      ? ""
                                      : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                    filterable: "",
                                    "allow-create": true,
                                    disabled: _vm.readonly,
                                    clearable: "",
                                    options: _vm.doorList,
                                    "label-field": "name",
                                    "value-field": "name",
                                    "unique-field": "uuid",
                                    "match-of-repeat-value":
                                      _vm.matchOfRepeatDoor
                                  },
                                  on: { change: _vm.doorsChangeHandler },
                                  model: {
                                    value: _vm.truckingInfo.doorName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "doorName",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.doorName"
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.$checkPermission([
                                          "button_Common_AddSite"
                                        ]),
                                        expression:
                                          "$checkPermission(['button_Common_AddSite'])"
                                      }
                                    ],
                                    staticClass: "vehicle-btn",
                                    attrs: {
                                      no: "addDoor",
                                      disabled: !_vm.isEdit,
                                      type: "primary",
                                      size: "mini"
                                    },
                                    on: { click: _vm.addDoor }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Partners.doorInformation"))
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: { label: _vm.$t("SeaExport.Tel") }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: { no: "46", disabled: _vm.readonly },
                                  model: {
                                    value: _vm.truckingInfo.doorManTel,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "doorManTel",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.doorManTel"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.AdditionalNotes")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    no: "47",
                                    disabled: _vm.readonly,
                                    "filter-chars": false,
                                    type: "textarea",
                                    rows: 3
                                  },
                                  model: {
                                    value: _vm.truckingInfo.remarks,
                                    callback: function($$v) {
                                      _vm.$set(_vm.truckingInfo, "remarks", $$v)
                                    },
                                    expression: "truckingInfo.remarks"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.truckingInfo.dischargingPortService
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.DischargingWay")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "400px" },
                                        attrs: {
                                          value: _vm.truckingInfo.dischargingWay
                                            ? _vm.truckingInfo.dischargingWay.split(
                                                ","
                                              )
                                            : [],
                                          no: "48",
                                          disabled: _vm.readonly,
                                          multiple: ""
                                        },
                                        on: {
                                          input: function(value) {
                                            _vm.truckingInfo.dischargingWay = value.join(
                                              ","
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "DROP" }
                                        }),
                                        _c("el-option", {
                                          attrs: { value: "LIVE UNLOAD" }
                                        }),
                                        _c("el-option", {
                                          attrs: { value: "EXCHANGE PALLETS" }
                                        }),
                                        _vm.job.lob === "AI"
                                          ? _c("el-option", {
                                              attrs: { value: "拼车" }
                                            })
                                          : _vm._e(),
                                        _vm.job.lob === "AI"
                                          ? _c("el-option", {
                                              attrs: { value: "整车" }
                                            })
                                          : _vm._e(),
                                        _vm.job.lob === "AI"
                                          ? _c("el-option", {
                                              attrs: { value: "快递" }
                                            })
                                          : _vm._e(),
                                        _vm.job.lob === "AI"
                                          ? _c("el-option", {
                                              attrs: { value: "空运" }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.truckingInfo.dischargingPortService
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.LatestDeliveryDate"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      ref: "actDeliveryDate",
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        no: "actDeliveryDate",
                                        disabled: _vm.readonly,
                                        type: "datetime",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm:ss"
                                      },
                                      on: {
                                        blur: function() {
                                          _vm.handleBlur(
                                            "actDeliveryDate",
                                            null,
                                            true,
                                            true,
                                            _vm.truckingInfo
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.truckingInfo.actDeliveryDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.truckingInfo,
                                            "actDeliveryDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "truckingInfo.actDeliveryDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: {
                                  label: _vm.$t("Partners.IdentityCard")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: { no: "60", disabled: _vm.readonly },
                                  model: {
                                    value: _vm.truckingInfo.driverIdCard,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "driverIdCard",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.driverIdCard"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          (_vm.job.lob === "SE" && !_vm.job.multipleCabinets) ||
          _vm.job.lob === "SI" ||
          _vm.job.lob === "RE" ||
          _vm.job.lob === "RI"
            ? _c("div", { staticClass: "app-main-inner-row operations" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cooperateEdit,
                        expression: "cooperateEdit"
                      }
                    ],
                    staticClass: "triggers"
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "48",
                              type: "primary",
                              disabled: !(
                                _vm.btnEnable.grpTruckOrderBtns ||
                                (_vm.toExoSystemHc &&
                                  _vm.job.trucking &&
                                  _vm.job.trucking.length > 0)
                              )
                            },
                            on: { click: _vm.linkUsageClickHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.AddPackingInfo")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "49",
                              type: "danger",
                              disabled: !(
                                _vm.btnEnable.grpTruckOrderBtns ||
                                (_vm.toExoSystemHc &&
                                  _vm.job.trucking &&
                                  _vm.job.trucking.length > 0)
                              )
                            },
                            on: { click: _vm.delLinkUsageClickHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.RemovePackingInfo")) +
                                " "
                            )
                          ]
                        ),
                        !_vm.btnEnable.grpTruckOrderBtns
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "50",
                                  type: "primary",
                                  disabled: !_vm.btnEnable.grpTruckOrderBtns
                                }
                              },
                              [_vm._v(_vm._s(_vm.command1) + " ")]
                            )
                          : _vm._e(),
                        _vm.btnEnable.grpTruckOrderBtns
                          ? _c(
                              "el-dropdown",
                              {
                                staticStyle: { "padding-left": "5px" },
                                attrs: {
                                  "split-button": "",
                                  type: "primary",
                                  disabled: !_vm.btnEnable.grpTruckOrderBtns
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.btnConnectedTruckClickHandler()
                                  },
                                  command: function(p) {
                                    _vm.command1 = p
                                    _vm.btnConnectedTruckClickHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(" " + _vm._s(_vm.command1) + " "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: {
                                      slot: "dropdown",
                                      disabled: !_vm.btnEnable.grpTruckOrderBtns
                                    },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns,
                                          command: _vm.$t(
                                            "SeaExport.DispatchTuckOrder"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.DispatchTuckOrder"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns,
                                          command: _vm.$t(
                                            "SeaExport.ModifyTuckOrder"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ModifyTuckOrder")
                                          ) + " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns,
                                          command: _vm.$t(
                                            "SeaExport.RevokeTuckOrder"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.RevokeTuckOrder")
                                          ) + " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns,
                                          command: _vm.$t(
                                            "SeaExport.SearchTuckOrder"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.SearchTuckOrder")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "51",
                              disabled: !_vm.btnEnable.grpTruckOrderBtns,
                              type: "primary"
                            },
                            on: { click: _vm.showTuckOrderLogClickHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ShowTuckOrderLog")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e(),
          (_vm.job.lob === "SE" && !_vm.job.multipleCabinets) ||
          _vm.job.lob === "SI" ||
          _vm.job.lob === "RE" ||
          _vm.job.lob === "RI"
            ? _c(
                "div",
                { staticStyle: { "flex-grow": "1", padding: "10px" } },
                [
                  _vm.gridVisible.dgUsage
                    ? _c("cargo-ag-grid", {
                        staticStyle: { width: "100%", height: "350px" },
                        attrs: {
                          "config-module": "130136",
                          no: "52",
                          "grid-options": _vm.gridOptions,
                          "grid-params": _vm.gridParams,
                          "column-defs": _vm.columnDefs,
                          "row-data": _vm.usages
                        },
                        on: {
                          "update:gridParams": function($event) {
                            _vm.gridParams = $event
                          },
                          "update:grid-params": function($event) {
                            _vm.gridParams = $event
                          },
                          gridReady: function(params) {
                            return (_vm.gridApi = params.api)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.gridVisible.dgUsageG7
                    ? _c("cargo-ag-grid", {
                        staticStyle: { width: "100%", height: "350px" },
                        attrs: {
                          "config-module": "130137",
                          no: "53",
                          "grid-options": _vm.gridOptions,
                          "grid-params": _vm.gridParams,
                          "column-defs": _vm.columnDefsG7,
                          "row-data": _vm.usages
                        },
                        on: {
                          "update:gridParams": function($event) {
                            _vm.gridParams = $event
                          },
                          "update:grid-params": function($event) {
                            _vm.gridParams = $event
                          },
                          gridReady: function(params) {
                            return (_vm.gridApi = params.api)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.job.lob === "SE" && _vm.job.multipleCabinets
            ? _c("div", { staticClass: "app-main-inner-row operations" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cooperateEdit,
                        expression: "cooperateEdit"
                      }
                    ],
                    staticClass: "triggers"
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "addCabinets",
                              type: "primary",
                              disabled: !_vm.btnEnable.grpTruckOrderBtns
                            },
                            on: { click: _vm.linkTruckRecordHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.AddPackingInfo")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "removeCabinets",
                              type: "danger",
                              disabled: !_vm.btnEnable.grpTruckOrderBtns
                            },
                            on: { click: _vm.dellinkTruckRecordHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.RemovePackingInfo")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "exportPackingInfo",
                              type: "primary",
                              disabled: !_vm.btnEnable.grpTruckOrderBtns
                            },
                            on: { click: _vm.exportTruckExcelData }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ExportPackingInfo")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-upload",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "padding-left": "5px"
                            },
                            attrs: {
                              action: "string",
                              "http-request": _vm.importTruckDataExcel,
                              "show-file-list": false,
                              disabled: !_vm.btnEnable.grpTruckOrderBtns,
                              accept: ".xls, .xlsx",
                              "before-upload": _vm.beforeUploadUsage
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "importPackingInfo",
                                  type: "primary",
                                  disabled: !_vm.btnEnable.grpTruckOrderBtns
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("SeaExport.ImportPackingInfo")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "exportErrorExcel",
                              type: "primary",
                              disabled:
                                !_vm.btnEnable.grpTruckOrderBtns ||
                                !_vm.importExcelResultID
                            },
                            on: { click: _vm.exportErrorExcel }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.DownloadImportResults")
                              ) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm.job.lob === "SE" && _vm.job.multipleCabinets
            ? _c(
                "div",
                { staticStyle: { "flex-grow": "1", padding: "10px" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      no: "gridCabinets",
                      "grid-options": _vm.gridOptions,
                      "grid-params": _vm.gridParams,
                      "column-defs": _vm.cabinetColumnDefs,
                      "row-data": _vm.truckingRecords
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        return (_vm.gridApi = params.api)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c("trucking-container-usage-link-dialog", {
        attrs: {
          visible: _vm.containerUsageDialog.visible,
          "job-uuid": _vm.job.uuid,
          "trucking-info-uuid": _vm.truckingInfo.uuid,
          "modify-usage-in-edit-mode": _vm.modifyUsageInEditMode,
          data: _vm.containerUsageDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerUsageDialog, "visible", $event)
          },
          selectContainerUsageHandler: _vm.selectContainerUsageHandler,
          saveContainerUsageData: _vm.saveContainerUsageHandler
        }
      }),
      _c("trucking-container-record-link-dialog", {
        attrs: {
          visible: _vm.containerTruckingRecordDialog.visible,
          "job-uuid": _vm.job.uuid,
          "trucking-info-uuid": _vm.truckingInfo.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(
              _vm.containerTruckingRecordDialog,
              "visible",
              $event
            )
          },
          selectTruckingRecordHandler: _vm.selectTruckingRecordHandler
        }
      }),
      _c("information-maintenance-dialog", {
        attrs: {
          visible: _vm.informationDialog.visible,
          site: _vm.informationDialog.site,
          title: _vm.informationDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.informationDialog, "visible", $event)
          },
          syncSiteToJob: _vm.syncSiteToJob,
          refresh: _vm.loadSites
        }
      }),
      _c("tuck-order-log-dialog", {
        attrs: {
          visible: _vm.truckOrderLogDialog.visible,
          "row-data": _vm.truckOrderLogDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.truckOrderLogDialog, "visible", $event)
          }
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "row-data": _vm.errorLogDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c("upload-common-file", {
        attrs: {
          visible: _vm.uploadCommonFileDialog.visible,
          model: _vm.uploadCommonFileDialog.model
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadCommonFileDialog, "visible", $event)
          }
        }
      }),
      _c("door-point-information", {
        attrs: {
          "v-if": _vm.addDoorDialog.visible,
          visible: _vm.addDoorDialog.visible,
          "show-area": _vm.toExoSystemHc,
          action: _vm.action,
          site: _vm.addDoorDialog.form
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.addDoorDialog, "visible", $event)
          },
          loadSites: _vm.loadSites
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }